import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import UserProfileModal from "../components/UserProfileModal";

function ProfileView() {
  const { userId } = useParams();
  const navigate = useNavigate();

  const handleClose = () => {
    if (window.history.length <= 2) {
      navigate("/discovery", { replace: true });
    } else {
      navigate(-1);
    }
  };

  return (
    <UserProfileModal
      userId={userId}
      isOpen={true}
      onClose={handleClose}
      renderAsPage={true}
    />
  );
}

export default ProfileView;
